import styles from './BasicLayout.module.scss';
import { MBLogo } from '../../icons/Icons';
import GlobalContext from '../../contexts/GlobalContext';
import MBFooter from '../../components/MBFooter/MBFooter';
import { FC, useContext } from 'react';

const PartnerLayout: FC = (props) => {
    const { coBranding, language } = useContext(GlobalContext);

    return (
        <div className={`${styles.pageBackground} ${coBranding.isDarkMode ? 'dark' : 'light'}`}>
            <div className={styles.container}>
                <header className={styles.header}>
                    <span className={styles.mbLogo} data-testid="mb-header-logo">
                        <MBLogo
                            width={'100%'}
                            height={'100%'}
                            title={language.common.mb}
                            fillColor={coBranding.isDarkMode ? '#ffffff' : undefined}
                        />
                    </span>
                </header>
                <main>{props.children}</main>
                <MBFooter />
            </div>
        </div>
    );
};

export default PartnerLayout;
